import { SyntheticEvent } from 'react';
import ClipboardUtility from '../../../common/utility/ClipboardUtility';
import { showSuccessFlush } from '../../../common/form/FrekulForm';
import { MusicAlbumEntity } from '../../types/MusicAlbumEntityTypes';
import { TunecoreReleaseEntity } from '../../types/TunecoreReleaseEntityTypes';

/**
 * SNS共有
 */
export default function MusicAlbumDetailsShareView({
  musicAlbum,
}: {
  musicAlbum: MusicAlbumEntity & {
    tunecore_release: TunecoreReleaseEntity,
  }
}) {
  if (musicAlbum.release_status !== 2 && musicAlbum.release_status !== 3) return null;
  // eslint-disable-next-line max-len
  if (musicAlbum.tunecore_release === null || musicAlbum.tunecore_release.linkcore_url === null) return null;

  const cancelEvent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleCopy = () => {
    ClipboardUtility.copy(musicAlbum.tunecore_release.linkcore_url || '');
    showSuccessFlush('URLをコピーしました。');
  };

  const url = encodeURIComponent(musicAlbum.tunecore_release.linkcore_url);
  const text = encodeURIComponent(`${musicAlbum.title} / ${musicAlbum.compound_artist_name}`);
  const hashtags = ['Frekul'];
  return (
    <div className="sns_button">
      { /* eslint-disable-next-line max-len */ }
      { /* eslint-disable-next-line jsx-a11y/control-has-associated-label */ }
      <a href={`https://twitter.com/share?text=${text}&url=${url}&hashtags=${hashtags.join(',')}`} rel="nofollow noreferrer" target="_blank"><img src="../../img/common/bt_tw.svg" alt="" /></a>
      { /* eslint-disable-next-line max-len */ }
      { /* eslint-disable-next-line jsx-a11y/control-has-associated-label */ }
      <a href={`https://www.facebook.com/share.php?u=${url}`} rel="nofollow noreferrer" target="_blank"><img src="../../img/common/bt_fb.svg" alt="" /></a>
      { /* eslint-disable-next-line max-len */ }
      { /* eslint-disable-next-line jsx-a11y/control-has-associated-label */ }
      <a href={`https://social-plugins.line.me/lineit/share?url=${url}`} rel="nofollow noreferrer" target="_blank"><img src="../../img/common/bt_line.svg" alt="" /></a>
      { /* eslint-disable-next-line max-len */ }
      { /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid */ }
      <a onClick={(e) => { cancelEvent(e); handleCopy(); }}><img src="../../img/common/bt_copy.svg" alt="" /></a>
    </div>
  );
}
